export class Entity {
  id?: string;
  code?: string;
  type?: string;
  name?: string;
}
